const FAVORITE_ENDPOINT = 'api/favorite'
const TRANSLATIONS = {
    copyToClipboard: {
        DE: "Kopieren",
        EN: "Copy",
        FR: "Copier",
        IT: "Copia"
    },
    copiedToClipboard: {
        DE: "Kopiert",
        EN: "Copied",
        FR: "Copié",
        IT: "Copiato"
    },
    hamburgerLabel: {
        closed: {
            DE: "Hauptnavigation öffnen",
            EN: "Open main navigation",
            FR: "Ouvrir la navigation principale",
            IT: "Apri la navigazione principale"
        },
        expanded: {
            DE: "Menü schliessen",
            EN: "Close menu",
            FR: "Fermer le menu",
            IT: "Chiudi menu"
        },
    },
    subnavigationLabel: {
        closed: {
            DE: "Navigation %s öffnen",
            EN: "Open %s navigation",
            FR: "Ouvrir %s navigation",
            IT: "Apri %s navigazione"
        },
        expanded: {
            DE: "Navigation %s schliessen",
            EN: "Close %s navigation",
            FR: "Fermer navigation %s",
            IT: "Chiudi navigazione %s"
        },
    },
    errorOverlayLoadingContent: {
        default: {
            DE: "Fehler beim laden des Inhaltes. Bitte erneut versuchen.",
            EN: "Error loading content. Please try again.",
            FR: "Erreur lors du chargement du contenu. Veuillez réessayer.",
            IT: "Errore durante il caricamento dei contenuti. Riprova."
        },
    },
};

// shorthand quick translation function
const __ = (name, state = null) => {
    const currLanguage = document.querySelector("html").getAttribute("lang").toLocaleUpperCase();
    if (currLanguage && TRANSLATIONS.hasOwnProperty(name) && TRANSLATIONS[name].hasOwnProperty(state)) {
        return TRANSLATIONS[name][state][currLanguage]
    } else if (currLanguage && TRANSLATIONS.hasOwnProperty(name)) {
        return TRANSLATIONS[name][currLanguage]
    }
}

function changeLocale(locale) {
    // change locale and keep the current URL incl. the query part
    var currentUrl = window.location.href;
    var url = new URL(currentUrl);
    // Set the `request_locale` parameter
    url.searchParams.set('request_locale', locale);
    // Change the window location to the new URL
    window.location.href = url.href;
    // Prevent default link behavior
    return false;
}

(function () {

    // toggle navigation on mobile
    const toggleNavigationIcon = (force = null) => {
        if (window.innerWidth >= 800) {
            return;
        }
        const navList = document.getElementById("navList");
        const hamIcon = document.querySelector('#toggleMenu i');
        const toggleButton = document.getElementById('toggleMenu');

        if (force !== null) {
            navList.classList.toggle("show", force);
            document.body.classList.toggle("mainnav-active", force);
        } else {
            navList.classList.toggle("show");
            document.body.classList.toggle("mainnav-active");
        }

        const expanded = navList.classList.contains("show");
        toggleButton.setAttribute('aria-expanded', expanded);
        toggleButton.setAttribute('aria-label', expanded ? "Menü schliessen" : "Menü öffnen");
        navList.setAttribute('aria-hidden', !expanded);


        if (expanded) {
            hamIcon.classList.remove("ph-list");
            hamIcon.classList.add("ph-x");
            hamIcon.classList.add("ph-fab");
            hamIcon.classList.add("ph-interactive");
            navList.focus();
        } else {
            hamIcon.classList.remove("ph-x");
            hamIcon.classList.remove("ph-fab");
            hamIcon.classList.remove("ph-interactive");
            hamIcon.classList.add("ph-list");
            toggleButton.focus();
        }
    };
    const handleKeyDown = (e) => {
        if (e.key === 'Escape') {
            toggleNavigationIcon(false);
        }
    };
    // Hamburger
    const ham = document.getElementById('toggleMenu');
    if (ham) {
        ham.setAttribute('aria-controls', 'navList');
        ham.setAttribute('aria-haspopup', 'true');
        ham.setAttribute('aria-expanded', 'false');

        ham.addEventListener('click', () => toggleNavigationIcon());
        document.addEventListener('keydown', handleKeyDown);
    }

    // Hover effect
    // document.querySelectorAll('.icov').forEach(function (el) {
    //     el.addEventListener('mouseenter', function (e) {
    //         e.preventDefault();
    //         var img = getImage(e);
    //         if (img) {
    //             img.src = img.src.replace('_0.svg', '_1.svg');
    //         }
    //     });
    //     el.addEventListener('mouseleave', function (e) {
    //         e.preventDefault();
    //         var img = getImage(e);
    //         if (img) {
    //             img.src = img.src.replace('_1.svg', '_0.svg');
    //         }
    //     });
    // });
    function getImage(e) {
        var img = e.target;
        if (img.tagName === "IMG") { return img; }
        return e.target.querySelector("img");
    }



    // greyout select with placeholder
    var greyout = document.getElementsByClassName('greyout');
    var greyOutSelect = function () {
        if (this.value === "") {
            this.classList.add('grey');
        } else {
            this.classList.remove('grey');
        }
    };

    for (var i = 0; i < greyout.length; i++) {
        greyout[i].addEventListener('change', greyOutSelect);
        if (greyout[i].value === "") {
            greyout[i].classList.add('grey');
        } else {
            greyout[i].classList.remove('grey');
        }
    }

    var sticky = document.querySelector('.navigation.sticky');
    if (sticky) {
        sticky.addEventListener('click', function (e) {
            var navList = document.getElementById("navList");
            navList.classList.remove("show");
            var menu = document.getElementById('toggleMenu');
            menu.firstElementChild.src = menu.firstElementChild.src.replace('close_B', 'hamburger');

        });
    }

    const anchornav = document.querySelector(".front #navList")

    if (anchornav) {
        const anchorLinks = anchornav.querySelectorAll("li a")
        let currentActiveIndex = -1; // Speichert den aktuellen aktiven Index
        let elementStates = new Map(); // Map, um Sichtbarkeitszustände aller Elemente zu speichern

        // define an observer instance
        var observer = new IntersectionObserver(onIntersection, {
            threshold: [0, 0.25, 0.5, 0.75, 1],
            rootMargin: "160px"
        });

        // callback is called on intersection change
        function onIntersection(entries) {
            entries.forEach(entry => {
                const targetHeight = entry.target.getBoundingClientRect().height;
                const relativeVisibility = entry.intersectionRect.height / targetHeight;
                const index = entry.target.dataset.index;

                // Sichtbarkeitsstatus in der Map aktualisieren
                if (entry.isIntersecting) {
                    elementStates.set(index, relativeVisibility);
                } else {
                    elementStates.delete(index);
                }
            });

            // Finde das sichtbarste Element
            let mostVisibleIndex = null;
            let highestVisibility = 0;
            elementStates.forEach((visibility, index) => {
                if (visibility > highestVisibility) {
                    highestVisibility = visibility;
                    mostVisibleIndex = index;
                }
            });

            // Nur wechseln, wenn ein neues Element dominanter ist
            if (
                mostVisibleIndex !== null &&
                (currentActiveIndex === -1 || mostVisibleIndex != currentActiveIndex)
            ) {
                // Setze alle Links auf inaktiv
                anchorLinks.forEach(link => link.classList.remove('active'));

                // Aktiviere das sichtbarste Element
                const link = anchorLinks[mostVisibleIndex];
                link.classList.add('active');
                currentActiveIndex = mostVisibleIndex; // Aktualisiere aktiven Index
            }
        }

        anchorLinks.forEach((link, index) => {
            try {
                const id = link.href.split("#")[1];
                // Korrigiere HTML-Struktur und beobachte das richtige Elternelement
                const target = (["ourcustomer", "ourservice"].indexOf(id) > -1)
                    ? document.getElementById(id).parentElement.parentElement
                    : document.getElementById(id).parentElement;
                target.dataset.index = index;
                observer.observe(target);
            } catch (e) {
                console.warn(e);
            }
        });


    }



    // Filter toggler that maintains open selection after actions like save, edit or delete
    $(function () {
        $('.filterToggler').click(function () {
            var classLinkID = "." + this.id;
            var display = $(classLinkID).css('display') == 'inline' ? 'none' : 'inline';
            $(classLinkID).css('display', display);

            var item = this.closest('.list-item');
            if (item) {
                item.nextElementSibling.classList.toggle("filtershow");
                var img = this.querySelector('img');
                if (item.nextElementSibling.classList.contains("filtershow")) {
                    img.src = img.src.replace('_1.svg', '_0.svg');
                } else {
                    img.src = img.src.replace('_0.svg', '_1.svg');
                }
            }
        });
    });

    //Expand Links public (not in use)
    var els = document.getElementsByClassName("unfold-a");
    for (var i = 0; i < els.length; i++) {
        els[i].addEventListener('click', function (e) {
            e.preventDefault();
            var img = this.querySelector('img');
            var src = img ? img.src : null;
            var item = e.target.parentElement.querySelector(".unfold-text");
            if (!item) { item = e.target.parentElement.parentElement.querySelector(".unfold-text"); }
            if (item) {
                if (item.classList.contains("pubshow")) {
                    item.classList.remove("pubshow");
                    img.src = src.replace('_0.svg', '_1.svg');
                }
                else {
                    item.classList.add("pubshow");
                    img.src = src.replace('_1.svg', '_0.svg');
                }
                return;
            }

            // filterlist
            var item = this.closest('.list-item');
            if (item) {
                item.nextElementSibling.classList.toggle("filtershow");
                var img = this.querySelector('img');
                if (item.nextElementSibling.classList.contains("filtershow")) {
                    img.src = img.src.replace('_1.svg', '_0.svg');
                } else { img.src = img.src.replace('_0.svg', '_1.svg'); }
            }
        });
    }

    // Filter filter-header
    document.querySelectorAll('.filter-header').forEach(function (el) {
        el.addEventListener('click', function (e) {
            //e.preventDefault();
            var el = e.target;
            while (el && !el.classList.contains("filter-item")) {
                el = el.parentElement;
            }
            if (el.classList.contains("active")) {
                el.classList.remove("active");
            } else {
                el.classList.add("active");
            }
        });
    });

    // Hide Filter by clicking outside
    document.addEventListener('click', function (event) {
        if (event.target.closest && !event.target.closest('.filter-item.active')) {
            document.querySelectorAll('.filter-item').forEach(function (element) {
                element.classList.remove('active');
            });
        }
    });

    // Delete-Links
    var els = document.getElementsByClassName("ask-shure");
    for (var i = 0; i < els.length; i++) {
        els[i].addEventListener('click', function (e) {
            if (!confirm(this.getAttribute("title"))) {
                e.preventDefault();
            };
        });
    }

    // Expand Links private
    var els = document.getElementsByClassName("expand-link");
    for (var i = 0; i < els.length; i++) {
        els[i].addEventListener('click', function (e) {
            e.preventDefault();
            var item = e.target.closest('.list-item');
            if (item) {
                if (item.classList.contains("active")) {
                    item.classList.remove("active");
                }
                else {
                    item.classList.add("active");
                }
            }
        });
    }

    document.querySelectorAll('a.tooltip-close').forEach(function (link) {
        link.addEventListener('click', function (event) {
            event.preventDefault();
            console.log('Dieser Link dürfte eigentlich nie ausgeführt werden...');
            return false;
        });
    });

    // Show Submenu
    const toggleSubNavigation = (trigger, submenu, force = null) => {
        // detect state if no state is forced
        if (force === null) {
            force = !submenu.classList.contains("active")
        }


        // hide all open ones
        document.querySelectorAll('.active').forEach(function (el) {
            if (el !== submenu && el.parentElement !== submenu) {
                el.classList.remove("active");

            }
        });


        // change classes
        submenu.classList.toggle("active", force);
        submenu.parentElement.classList.toggle("active", force);

        // aria stuff
        submenu.setAttribute('aria-hidden', !force);
        submenu.setAttribute('aria-expanded', force);
        if (trigger) {
            let label = __("subnavigationLabel", force ? "expanded" : "closed")
            label = label.replace("%s", trigger.title || trigger.textContent)
            trigger.setAttribute('aria-label', label);
        }


        if (force) {
            submenu.focus();
        }
    };

    document.querySelectorAll('#navList li a, .context-menu-client, .context-menu-lang, .context-menu-user').forEach(function (el) {
        el.addEventListener('click', function (e) {

            // smooth scroll for anchornav
            if (e.currentTarget.href && e.currentTarget.href.includes("#")) {
                e.preventDefault();
                const splitted = e.currentTarget.href.split("#");
                if (splitted && splitted.length > 1) {
                    toggleNavigationIcon();
                    document.getElementById(splitted[1]).scrollIntoView({
                        block: "start",
                        behavior: 'smooth'
                    });
                }
            }


            //   document.dispatchEvent(new MouseEvent('click'));
            var parent = e.currentTarget.parentElement;
            var item = parent.querySelector(".subnavigation");

            if (item) {
                // special for user menu: close mainnav when opened 
                if (el.classList.contains("context-menu-user")) {
                    toggleNavigationIcon(false);
                }


                e.preventDefault();
                toggleSubNavigation(e.currentTarget, item);
            }
            else {
                document.querySelectorAll('.active:not(.subnavigation.active)').forEach(function (el) {
                    el.classList.remove("active");
                });
                this.classList.add("active");
                toggleNavigationIcon(false);
            }
        });
    });

    // Hide Submenu by clicking outside
    document.addEventListener('click', function (event) {
        const submenu = document.querySelector(".active .subnavigation");
        const targetElement = event.target;
        if (targetElement.classList?.contains("nav-menu")) return;

        if (submenu && !submenu.contains(targetElement)) {
            toggleSubNavigation(null, submenu, false)
        }
    });


    // Kontotext
    var ktxt = document.getElementById('kontotext');
    if (ktxt && ktxt.textContent.length > 50) {
        ktxt.classList.add('ktxt-long');
    }

    // Sticky Navigation
    window.addEventListener('scroll', function () {
        const navigation = document.querySelector('.navigation.front');
        if (navigation) {
            if (window.scrollY > 120) {
                navigation.classList.add('sticky');
            } else if (window.innerWidth > 800) {
                navigation.classList.remove('sticky');
            }
        }
    });


    document.addEventListener('DOMContentLoaded', () => {
        const header = document.querySelector('.header');
        let lastScrollTop = 0; // Speichert die letzte Scrollposition

        window.addEventListener('scroll', () => {
            const currentScroll = window.pageYOffset || document.documentElement.scrollTop;
            document.body.classList.remove('header-visible', 'header-hidden', 'header-partial');
            // Ganz oben: Header immer sichtbar
            if (currentScroll <= 160) {
                header.style.transform = 'translateY(0)';
                document.body.classList.add('header-visible');
                return;
            }

            // Nach unten scrollen: Header ausblenden
            if (currentScroll > lastScrollTop && window.scrollY > 160) {
                header.style.transform = 'translateY(-100%)';
                document.body.classList.add('header-hidden');
            }
            // Nach oben scrollen: Header einblenden
            else {
                header.style.transform = `translateY(${header.classList.contains("backend") ? '-50px' : '0px'})`;
                document.body.classList.add('header-partial');
            }

            lastScrollTop = currentScroll;
        });
    });



    function preloadImages() {
        const imageUrls = [
            'arrow_left.svg',
            'expand_more_blau.svg',
            'expand_less_w.svg',
            'Download-Icon_neg.svg',
            'Download-Icon.svg',
            'Drag-Icon.svg',
            'copy-Icon_neg.svg',
            'copy-Icon.svg',
            'Upload-Icon_neg.svg',
            'upload.svg'
        ];

        imageUrls.forEach(url => {
            const img = new Image();
            img.src = '../../image/' + url; // <= Markus: Pfad anpassen!
        });
    }

    // preloadImages();


    // DASHBOARD DYNAMIC
    const onOverlayClose = () => {
        const overlay = document.querySelector("#dashboard-overlay");
        overlay.classList.remove("dashboard-active")
    }
    const dashboardItems = document.querySelectorAll(".open-overlay");
    const openOverlay = (e, item) => {
        const overlay = document.querySelector("#dashboard-overlay");
        overlay.classList.add("dashboard-active")
        const header = overlay.querySelector(".inner > header")
        header.querySelector("span").innerHTML = item.dataset.title
        header.querySelector("i").addEventListener("click", onOverlayClose)
        const main = overlay.querySelector(".inner > main")
        if (item.dataset.href) {
            e.preventDefault();
            const url = new URL(item.dataset.href, window.location)
            url.searchParams.set("ajax", 1)
            fetch(url.toString())
                .then(res => res.text())  // <- HTML als Text auslesen
                .then(html => {
                    main.classList.remove("error");
                    main.innerHTML = html;  // <- in dein Ziel-Element einfügen
                    const newOverlayItems = main.querySelectorAll(".open-overlay");
                    newOverlayItems.forEach((newItem) => {
                        newItem.addEventListener("click", (e) => {
                            openOverlay(e, newItem)
                        })
                    })
                })
                .catch(err => {
                    main.innerHTML = __("errorOverlayLoadingContent", "default");
                    main.classList.add("error")
                })
        } else {
            const parent = initialItem.closest(".item")
            main.innerHTML = parent.innerHTML;
            parent.dataset.ogclasses = parent.className;
        }
    }
    dashboardItems.forEach((initialItem) => {
        initialItem.addEventListener("click", (e) => {
            openOverlay(e, initialItem)
        })
    })
    const dashboardOverlayCloseLayer = document.querySelector("#dashboard-overlay .closelayer");

    if (dashboardOverlayCloseLayer) {
        dashboardOverlayCloseLayer.addEventListener("click", onOverlayClose);
    }



})();



//$(function(){

/*
<!--  Contextmenus -->
<ul id="contextMenuExample" class="dropdown-menu np-context-menu np-popup"
    role="menu" style="display: none">
    <li class="dropdown-item"><a href="{url alle}">
            <div class="left">Durchsuchen</div>
            <div class="right">
                <img class="icov" src="../../image/book_0.svg" />
            </div>
    </a></li>
 */
$(".context-menu-ress").npContextMenu({
    menuSelector: "#contextMenuRess",
    onMenuOptionSelected: function ($invokedOn, $selectedMenu) {
        document.location.href = $selectedMenu.parents("a").attr("href");
    }
});
$(".context-menu-alert").npContextMenu({
    menuSelector: "#contextMenuAlert",
    onMenuOptionSelected: function ($invokedOn, $selectedMenu) {
        document.location.href = $selectedMenu.parents("a").attr("href");
    }
});
$(".context-menu-anl").npContextMenu({
    menuSelector: "#contextMenuAnl",
    onMenuOptionSelected: function ($invokedOn, $selectedMenu) {
        document.location.href = $selectedMenu.parents("a").attr("href");
    }
});

$(".context-menu-fav").npContextMenu({
    // menuSelector: "#contextMenuFav",
    onMenuOptionSelected: function ($invokedOn, $selectedMenu) {
        document.location.href = $selectedMenu.parents("a").attr("href");
    }
});



$(".context-menu-test").npContextMenu({
    menuSelector: "#contextMenuTest",
    onMenuOptionSelected: function ($invokedOn, $selectedMenu) {
        document.location.href = $selectedMenu.parents("a").attr("href");
    }
});

$(".context-menu-test1").npContextMenu({
    menuSelector: "#contextMenuTest1",
    onMenuOptionSelected: function ($invokedOn, $selectedMenu) {
        document.location.href = $selectedMenu.parents("a").attr("href");
    }
});

$(".context-menu-test2").npContextMenu({
    menuSelector: "#contextMenuTest2",
    onMenuOptionSelected: function ($invokedOn, $selectedMenu) {
        document.location.href = $selectedMenu.parents("a").attr("href");
    }
});
$(".context-menu-test3").npContextMenu({
    menuSelector: "#contextMenuTest3",
    onMenuOptionSelected: function ($invokedOn, $selectedMenu) {
        document.location.href = $selectedMenu.parents("a").attr("href");
    }
});
$(".context-menu-test4").npContextMenu({
    menuSelector: "#contextMenuTest4",
    onMenuOptionSelected: function ($invokedOn, $selectedMenu) {
        document.location.href = $selectedMenu[0].href
    }
});


// Vereinfachung
$('.context-autoloader').each(function () {
    var dataId = $(this).attr('data-id');

    $(this).npContextMenu({
        menuSelector: '#' + dataId,
        onMenuOptionSelected: function ($invokedOn, $selectedMenu) {
            document.location.href = $selectedMenu.parents("a").attr("href");
        }
    });
});

var scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;
if (scrollbarWidth > 0) {
    document.documentElement.style.setProperty(
        '--scrollbarWidth',
        scrollbarWidth + 'px'
    );
}

/* reusable hiddenbox render function */
let timeoutCopy = null;
const copyToClipboard = (container, value) => {
    clearTimeout(timeoutCopy)
    navigator.clipboard.writeText(value);
    container.classList.add("is-copied");
    timeoutCopy = setTimeout(() => {
        container.classList.remove("is-copied");
    }, 500)
}
const onHideToggle = (container, content, hide) => {
    container.classList.toggle("show-active")
    if (container.classList.contains("show-active")) {
        content.innerText = container.dataset.value
        hide.classList.remove("ph-eye")
        hide.classList.add("ph-eye-slash")
    } else {
        content.innerText = '•'.repeat(__("copyToClipboard").length);
        hide.classList.add("ph-eye")
        hide.classList.remove("ph-eye-slash")
    }
}
const onHiddenEnter = (container, content) => {
    if ((container.classList.contains("show-active"))) {
        // content.innerText = __("copyToClipboard")
        return
    }
    // interpolate whitespaces to match width
    const extendLen = container.dataset.value.length - __("copyToClipboard")
    const finalString = extendLen <= 0 ? __("copyToClipboard") : __("copyToClipboard") + '&nbsp;'.repeat(extendLen)
    content.innerHTML = __("copyToClipboard")
}
const onHiddenLeave = (container, content) => {
    content.innerText = (container.classList.contains("show-active")) ? container.dataset.value : '•'.repeat(__("copyToClipboard").length)
}
const createHiddenBox = (label, value) => {
    const container = document.createElement("div")
    container.className = "hiddenbox"
    container.dataset.copiedtext = __("copiedToClipboard")
    const lbl = document.createElement("span");
    lbl.className = "label"
    lbl.innerText = label
    const content = document.createElement("span");
    content.className = "content"
    container.dataset.value = value
    content.innerText = '•'.repeat(__("copyToClipboard").length);
    const hide = document.createElement("button");
    hide.className = "ph-eye ph ph-interactive"
    container.appendChild(lbl)
    container.appendChild(content)
    container.appendChild(hide)
    hide.addEventListener("click", onHideToggle)
    content.addEventListener("click", copyToClipboard)
    return container;
}

/* render every hiddenbox we can find */
document.querySelectorAll(".hiddenbox").forEach((container) => {
    container.classList.add("star")
    const icon = container.querySelector(".ph");
    const content = container.querySelector(".content");
    if (!icon || !content) {
        return;
    }
    container.dataset.copiedtext = __("copiedToClipboard")
    container.dataset.value = content.innerText
    content.innerText = '•'.repeat(__("copyToClipboard").length);
    content.addEventListener("mouseenter", () => onHiddenEnter(container, content))
    content.addEventListener("mouseleave", () => onHiddenLeave(container, content))
    content.addEventListener("click", () => copyToClipboard(container, container.dataset.value))
    icon.addEventListener("click", () => onHideToggle(container, content, icon))
})


/* independent favorite fn */
const setFavorite = async (ctnid, state) => {

    const method = !state ? 'DELETE' : 'PUT';

    try {
        const response = await fetch(FAVORITE_ENDPOINT, {
            method,
            headers: {
                'Content-Type': 'application/json'
            },
            credentials: 'include',
            body: JSON.stringify({ ctnid })
        });

        if (!response.ok) {
            // check for erorr message
            const data = await response.json();
            const errMessage = data && data.message || "error"
            return { error: true, message: errMessage }
        }
        // check for 200 errors
        return await response.json();

    } catch (error) {
        console.warn(error)
        return { error: true, message: errMessage }
    }
}
document.querySelectorAll(".favorite-standalone").forEach(async (favElem) => {
    const star = document.createElement("button");
    let timeoutFav = null;
    star.className = "star ph ph-star ph-interactive ph-fab";
    star.textContent = "";
    const ctnid = favElem.dataset.ctnid
    if (!ctnid) {
        return;
    }
    if (favElem.dataset.active === "true" || favElem.dataset.active === true) {
        star.classList.add("app-active")
    }
    star.addEventListener("click", async (e) => {
        e.preventDefault();
        e.stopPropagation();
        if (e.target.classList.contains("app-active")) {
            e.target.classList.remove("app-active")
            const isSuccess = await setFavorite(ctnid, false)
            if (isSuccess.success === true) {
                e.target.classList.remove("ph-star")
                e.target.classList.add("ph-x");
                e.target.classList.add("ph-bounce");
                clearTimeout(timeoutFav);
                timeoutFav = setTimeout(() => {
                    e.target.classList.add("ph-star")
                    e.target.classList.remove("ph-x")
                    e.target.classList.remove("ph-bounce")
                }, 1000)
            } else {
                notif({
                    msg: isSuccess.message || 'N/A',
                    type: "error",
                    position: "bottom",
                    opacity: "0.9",
                    timeout: 3000,
                    multiline: true,
                    autohide: true,
                    clickable: false
                });
            }
        }
        else {
            e.target.classList.add("app-active")
            const isSuccess = await setFavorite(ctnid, true)
            if (isSuccess.success === true) {
                e.target.classList.remove("ph-star")
                e.target.classList.add("ph-check");
                e.target.classList.add("ph-bounce");
                clearTimeout(timeoutFav);
                timeoutFav = setTimeout(() => {
                    e.target.classList.add("ph-star")
                    e.target.classList.remove("ph-check")
                    e.target.classList.remove("ph-bounce")
                }, 1000);
            } else {
                notif({
                    msg: isSuccess.message || 'N/A',
                    type: "error",
                    position: "bottom",
                    opacity: "0.9",
                    timeout: 3000,
                    multiline: true,
                    autohide: true,
                    clickable: false
                });
            }
        }
    });
    favElem.append(star)
})